/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function CalendarDollarIcon(props) {
  return (
    <svg {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.8335 17.5H5.00016C4.55814 17.5 4.13421 17.3244 3.82165 17.0118C3.50909 16.6993 3.3335 16.2754 3.3335 15.8333V5.83333C3.3335 5.39131 3.50909 4.96738 3.82165 4.65482C4.13421 4.34226 4.55814 4.16667 5.00016 4.16667H15.0002C15.4422 4.16667 15.8661 4.34226 16.1787 4.65482C16.4912 4.96738 16.6668 5.39131 16.6668 5.83333V8.33333M13.3335 2.5V5.83333M6.66683 2.5V5.83333M3.3335 9.16667H13.7502M17.5002 12.5H15.4168C15.0853 12.5 14.7674 12.6317 14.5329 12.8661C14.2985 13.1005 14.1668 13.4185 14.1668 13.75C14.1668 14.0815 14.2985 14.3995 14.5329 14.6339C14.7674 14.8683 15.0853 15 15.4168 15H16.2502C16.5817 15 16.8996 15.1317 17.134 15.3661C17.3685 15.6005 17.5002 15.9185 17.5002 16.25C17.5002 16.5815 17.3685 16.8995 17.134 17.1339C16.8996 17.3683 16.5817 17.5 16.2502 17.5H14.1668M15.8335 17.5V18.3333M15.8335 11.6667V12.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

CalendarDollarIcon.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default CalendarDollarIcon
